import { gql } from '@biletiniz/apollo';

export const VERIFY_RESET_PASSWORD_CODE = gql`
  mutation verifyResetPasswordCode($username: String!, $code: String!) {
    verifyResetPasswordCode(username: $username, code: $code) {
      status
      message
    }
  }
`;
